<div
  class="wrapper"
  [style.borderColor]="currentBorderColor()"
  [ngClass]="{ error: error() !== '' }"
>
  <div class="button">
    <button (click)="onClickDelete()">
      <i class="fal fa-trash-alt"></i>
    </button>
  </div>
  <div class="separator"></div>
  <div class="input">
    <input
      #inputElement
      [type]="'number'"
      [value]="defaultValue() || ''"
      [max]="max()"
      [min]="0"
      (change)="onChange()"
      (blur)="onBlur()"
    />
  </div>
</div>
